import { Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Grid2 from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from 'axios';
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import io from "socket.io-client";
import Axios from "../../Axios";
import consts from "../../constant";
import Header from "../Header/Header";
import "./Suport.css";
const drawerWidth = 260;
function Support() {
  const theme = useTheme();
  const location = useLocation()
  const navigate = useNavigate()
  const isMounted = useRef(false);
  const chatContainerRef = useRef(null);

  const token = localStorage.getItem("adminToken");
  
  
  // const [usertype, setUserType] = useState('')
  const [title, setTitle] = useState('Support')

  const [playCard, setPlaycard] = useState([]);
  const [userType, setUserType] = useState('')
  const [chat, setChat] = useState('')
  const [showMob, setShowMob] = useState(false);
  const [loader, setLoader] = useState(false)
  const [ticketData, setTicketData] = useState()
  const [room_id, setRoom_id] = useState()
  const [showd, setShowd] = useState(null)
  // const [selcMsg, setSelcMsg] = useState()
  const [oneData, setOneData] = useState([])
  const [reason, setReason] = useState()
  const [load, setLoad] = useState()
  const [adminData, setAdminData] = useState()
  const [oneTic, setOneTic] = useState()
  const [accord, setAccord] = useState(false)
  const [reasonErr, setReasonErr] = useState()

 const socketInstance = io.connect(consts?.socketUrl, { path: "/socket" });
  // const socketInstance = io.connect(consts?.socketUrl);

  const matches = useMediaQuery(theme.breakpoints.up("md"));
  
  useEffect(() => {

    socketInstance.on('connect', () => {
    });

    

    socketInstance.on('connect_error', (error) => {
      console.log('Connection error:', error);
    });

    return () => {
      if (socketInstance) {
        socketInstance.disconnect();
      }
    }
  }, []);
  
  useEffect(() => {
    getTickets()
  }, []);

  useEffect(() => {
    if (token) {
      var user = window.localStorage.getItem("adminToken");
      // const userType = decryptData(user);
      setUserType(user);
    }
  }, [token]);

  useEffect(() => {
    if (location?.state?.id) {
      setShowd(location?.state?.id);
      getOneTicket(location?.state?.id);
      msgSeen(location?.state?.id);
      updateAgeById(location?.state?.id);

      setTimeout(() => {
        navigate(location.pathname, { replace: true, state: null });
        getTickets()
      }, 5000)
    }
  }, [location?.state?.id])

  useEffect(() => {
    if (room_id != undefined && !isMounted.current) {
      // Join the room
      socketInstance.emit('join', { room: room_id });
      // Event listener for receiving messages
      const handleReceive = (data) => {
        console.log(data, 'ismounted time');
        const msgg = {
          msg: data.message,
          seen: false,
          id: data.id,
          time: Date.now(),
        };
        console.log(msgg, 'msgg')
        
        setOneTic(prevOneTic => (
          [...prevOneTic,
         msgg]
        ));
        setTimeout(async () => {
          await msgSeen(room_id);
        }, [2000])
      };

      socketInstance.on("receive", handleReceive);

      isMounted.current = true;
      // Cleanup listener when component unmounts or room_id changes
      return () => {
        socketInstance.off("receive", handleReceive);
        isMounted.current = false;
      };

    }
  }, [room_id]);
  useEffect(() => {
    if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
}, [oneTic]);

  const handleAccord = () => {
    setAccord(!accord)
    setReason()
  }

  const getTickets = async () => {
    console.log("getTickets Started");
    
    try {
      const { data } = await axios.get(`${consts.BackendUrl}/support/getallticket`, {
        headers: {
          Authorization: window.localStorage.getItem('adminToken'),
        }
      })
      console.log(data,"dataaaa");
      
      if (data?.success == true) {
        setChat(data?.result)
      }
    } catch (error) {
      console.log("🚀 ~ getTickets ~ error:", error)
    }
  }



const getOneTicket = async (one) => {
  console.log(one, "getoneticket");

  const id = one?._id;
  console.log(id);

  try {

    const { data } = await axios.post(`${consts.BackendUrl}/support/getOneTicket`, { id: id },
      {
        headers: {
          Authorization: window.localStorage.getItem('adminToken'),
        },
      });

    console.log(data, "getoneticket-data");
    


    if (data.success) {
      setTicketData(data?.result);
      const ticketData = data.result[0]; 
      console.log(ticketData,"ticketData");
      
    const messageArray = ticketData.Message; 
    setOneTic(messageArray)
    console.log(messageArray,"12222222221");
    

    }
  } catch (error) {
    // Hide loader and log any error
    setLoader(false);
    console.log("🚀 ~ getOneTicket ~ error:", error);
  }
};



  const msgSeen = async (id) => {
    try {
      await Axios.post('/support/messageseen', { id: id }, {
        headers: {
          Authorization: window.localStorage.getItem('adminToken'),
        }
      })
    } catch (error) {
      console.log("🚀 ~ msgSeen ~ error:", error)
    }
  }

  const updateAgeById = (id) => {
    // Create a copy of the current array
    const updatedArray = playCard?.map(item => {
      // Check if the current item's id matches the id we want to update
      if (item._id == id) {
        // Return a new object with updated age
        return { ...item, msgcount: 0 };
      }
      // Return the item unchanged if it doesn't match
      return item;
    });

    // Update state with the new array
    setPlaycard(updatedArray);
  };

  const updateTicket = async () => {
    try {
      if (ticketData?.Status == 'closed') {
        toast.error('Your Ticket is Closed')
      }
      else {
        socketInstance.emit('join', {
          room: room_id
        })
        socketInstance.emit('send', {
          room: room_id,
          message: updated,
          seen: false,
          id: 'admin'
        })
        const payload = {
          room: room_id,
          id: 'admin',
          message: updated
        }
        console.log(payload, "message");
        
        const { data } = await axios.post(`${consts?.BackendUrl}/support/updateticket`, payload,
          {
            headers: {
              Authorization: window.localStorage.getItem('adminToken')
            }
          }
        )
        if (data?.success) {
         
          console.log("successfully");
        }
      }
    } catch (error) {
      console.log('🚀 ~ updateTickets ~ error', error);
    }
  }



  const closeTicket = async () => {
    try {
      if (reason == undefined) {
        setReasonErr('Please Enter Reason')
      }
      else {
        socketInstance.emit('join', {
          room: room_id
        })
        socketInstance.emit('sendReason', {
          room: room_id,
          reason: reason,
          status: 'closed',
          id: 'admin'
        })
        setLoad(true)
        const payload = {
          id: room_id,
          reason: reason
        }

        const { data } = await Axios.post('/support/closeticket', payload, {
          headers: {
            Authorization: window.localStorage.getItem('adminToken')
          }
        })
        if (data.success) {
          setLoad(false)
          toast.success(data.message)
          setReason()
          handleAccord()
          getOneTicket(room_id)
        }
      }
    } catch (error) {
      setLoad(false)
      console.log("🚀 ~ closeTicket ~ error:", error)
      toast.error(error.response.data.message)
      handleAccord()
    }
  }


  const [perChat, setPerChat] = useState();

  

  const [display, setDisplay] = useState();

  

  //search

  const [search, setSearch] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  const [message, setMessage] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const [updated, setUpdated] = useState("");

  const handleChangeSend = (event) => {
    setUpdated(event.target.value);
  };

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      // e.preventDefault();
      handleClickSend();
    }
  };

  const handleChatData = (val) => {
    getOneTicket(val)
    setPerChat(val?.Message)
    console.log(val,"handleChatData");
    console.log(val?._id,"id");
    setRoom_id(val?._id)
    console.log(room_id,"sxaccccccccccccc");
    
    console.log(val?.id?.Message,"handleChatdata2")
 

  }

  const handleClickSend = async (e) => {
 
  if (updated?.trim() !== '') {
    // setMessage([...message, updated])
    const val = {
      msg: updated,
      seen: false,
      id: "admin",
      time: Date.now(),
    };
    // setOneTic([...oneTic, val])
    setUpdated('')
  }
  console.log('handle send button');
  updateTicket()
  };
  
  

  const handleDeleteTodo = (index) => {
    const newTodos = [...message];
    newTodos.splice(index, 1);
    setMessage(newTodos);
  };

  //image upload

  const [imageUrl, setImageUrl] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    console.log(reader, "result of file");

    reader.onloadend = () => {
      setImageUrl(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  // internal css

  const msgBg = {
    height: "670px",
    overflowY: "scroll",
    margin: "0px",
    backgroundImage: `url(${imageUrl})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    opacity: "0.7",
  };

  const handleOpenedTic =()=>{
    console.log("hi");
    
  }
  const handleClosedTic =()=>{
    console.log("h1");
    
  }

  function getTimeOrDateFromTimestamp(timestamp) {
    const now = new Date(); // Get current date and time
    const date = new Date(timestamp); // Create a Date object from the timestamp
  
    // Check if the date of the timestamp is today
    if (date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate()) {
  
        // Extract hours, minutes, and seconds
        const hours = String(date.getHours()).padStart(2, '0'); // Format hours
        const minutes = String(date.getMinutes()).padStart(2, '0'); // Format minutes
  
        // Return the time in hh:mm:ss format
        return `${hours}:${minutes}`;
    } else {
        // Extract month and day
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Format month (0-based index)
        const day = String(date.getDate()).padStart(2, '0'); // Format day
  
        // Return the date in mm-dd format
        return `${month}-${day}`;
    }
  }
  if (!chat) {
    return <div>Loading...</div>;
  }
  
  const filteredChat = chat?.filter(row => {
    const searchTerm = (typeof search === "string" ? search : "").toLowerCase();
    const match = row?.Title?.toLowerCase().includes(searchTerm);
    console.log(`Row: ${row?.Title}, Match: ${match}`);
    return match;
  });
  
  console.log("Filtered Chat:", filteredChat);
  
  
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 5,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            marginTop: "50px",
          }}
        >
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 8, xl: 9 }}>
              <div className="colab-msg-box">
                {/* <div className="colab-avatar-cont vr">
                                    <Stack direction="row" spacing={1}>

                                        <Avatar sx={{ width: 30, height: 30 }} alt="Remy Sharp" src={chat[0].img} />

                                    </Stack>
                                </div> */}
                <div className="colab-chat-area msg">
                  <div className="chat-area-inner-text vr">
                    
                  </div>
                  {/* {console.log(message, "messages1111111")} */}


{oneTic?.length > 0 ? (
  oneTic?.map((dat, ind) => {
    const isCurrentUser = dat?.id == "admin";

    return (
      <div
        key={ind}
        style={{
          display: 'flex',
          justifyContent: isCurrentUser ? 'flex-end' : 'flex-start', // Align based on user or admin
          marginBottom: '10px', // Optional, space between messages
        }}
      >
        <div>
          <Avatar
            sx={{ width: 30, height: 30 }}
            alt="User Avatar"
            src={perChat?.img} // Assuming 'perChat?.img' contains the user's image
          />
        </div>
        <div
          style={{
            padding: '10px',
            borderRadius: '10px',
            maxWidth: '70%',
            color:'white', 
            textAlign: 'left', // Align text to the left inside the bubble
            wordWrap: 'break-word', // Make sure text wraps inside the bubble
          }}
        >
          {/* <div className="username">{dat.title}</div> */}
          <div className="txt1">{dat?.msg}</div>
          {console.log(dat?.msg)} {/* This will log the message */}
          <div
            style={{
              fontSize: '12px',
              color: '#888', // Lighter color for timestamp
              textAlign: 'right', // Align the time on the right
            }}
          >
            {getTimeOrDateFromTimestamp(dat?.time)}
          </div>
        </div>
      </div>
    );
  })
) : (
  <div>No data</div>
)}


                </div>

                <div className="colab-text-input">
                  <div class="messageBox">
                    <input
                      required=""
                      placeholder="Message..."
                      type="text"
                      id="messageInput"
                      value={updated}
                      onChange={handleChangeSend}
                      onKeyDown={handleEnterKeyPress}
                    />
                    <button id="sendButton" onClick={handleClickSend}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 664 663"
                      >
                        <path
                          fill="none"
                          d="M646.293 331.888L17.7538 17.6187L155.245 331.888M646.293 331.888L17.753 646.157L155.245 331.888M646.293 331.888L318.735 330.228L155.245 331.888"
                        ></path>
                        <path
                          stroke-linejoin="round"
                          stroke-linecap="round"
                          stroke-width="33.67"
                          stroke="#6c6c6c"
                          d="M646.293 331.888L17.7538 17.6187L155.245 331.888M646.293 331.888L17.753 646.157L155.245 331.888M646.293 331.888L318.735 330.228L155.245 331.888"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </Grid2>

            {matches && (
              <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 3 }}>
                <div className="msglist">
                  <div className="msg-list-head display-2">
                    <h2 className="chats">Chats</h2>

                    {/* <div id="firstFilter" class="filter-switch">
                      <input
                        checked=""
                        id="option1"
                        name="options"
                        type="radio"
                        onClick={handleOpenedTic}
                      />
                      <label class="option" for="option1">
                        Opened
                      </label>
                      <input id="option2" name="options" type="radio" onClick={handleClosedTic} />
                      <label class="option" for="option2">
                        Closed
                      </label>
                      <span class="background"></span>
                    </div> */}
                  </div>
                  <div className="msg-list-input">
                    <div class="group">
                      <svg
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        class="search-icon"
                      >
                        <g>
                          <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
                        </g>
                      </svg>

                      <input
                        id="query"
                        class="input"
                        type="search"
                        placeholder="Search..."
                        name="searchbar"
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="msg-list-area">
  {filteredChat && filteredChat.length > 0 ? (
    filteredChat
      .filter((row) => {
        // Ensure search is defined and is a string, and row has a name or title to check
        const searchTerm = typeof search === "string" ? search.toLowerCase() : "";
        
        // Adjusting the logic to search for row.Title or row.name (depending on your data structure)
        return row?.Title?.toLowerCase().includes(searchTerm) || row?.name?.toLowerCase().includes(searchTerm);
      })
      .map((row, ind) => {
        return (
          <div
            key={ind}
            className={
              perChat?.name !== row?.name
                ? "msg-list-chat-main display-1 cursor"
                : "msg-list-chat-main display-1 cursor active"
            }
            onClick={() => {
              handleChatData(row);
            }}
          >
            <div>
              <Avatar
                sx={{ width: 56, height: 56 }}
                alt="Remy Sharp"
                src={row?.img}
              />
            </div>
            <div className="msg-list-chat-name" style={{ width: "100%" }}>
              {row?.Title}
              <div className="chat-desc display-2" id="sentence">
                {row?.Message[ind]?.msg?.length > 30
                  ? row?.Message[ind]?.msg?.substring(0, 28) + "..."
                  : row.Message[ind]?.msg}
              </div>
            </div>
          </div>
        );
      })
  ) : (
    <div>No chats available</div>
  )}
</div>

                </div>
              </Grid2>
            )}
          </Grid2>
        </Box>
      </Box>
    </div>
  );
}

export default Support;
